export interface ResolveLegalEntityIdParams {
  /** Edit of an already loaded legal entity. */
  isEdit: boolean;
  /** `values.id` of the form: the loaded legal entity's id in edit mode. */
  valuesId?: string;
  /** `id` of the save response. */
  responseId?: string | null;
  /** Set when the legal entity is registered on a risk (subscription process). */
  riskId?: string;
  /** Reads back the legal entity registered on the risk. */
  fetchRiskPersonId: (riskId: string) => Promise<string | undefined>;
}

/**
 * Id of the legal entity to sync the subsidiaries against, after the legal entity was saved.
 * Registered on a risk, the save response carries the id of the risk-person link, not the
 * legal entity's: in creation, the legal entity is read back on the risk.
 */
export async function resolveLegalEntityId({
  isEdit,
  valuesId,
  responseId,
  riskId,
  fetchRiskPersonId
}: ResolveLegalEntityIdParams): Promise<string | undefined> {
  if (isEdit) {
    return valuesId || undefined;
  }
  if (riskId) {
    return (await fetchRiskPersonId(riskId)) || undefined;
  }
  return responseId || undefined;
}
